import { render } from "./bind-wechat.vue?vue&type=template&id=5deef459&scoped=true&ts=true"
import script from "./bind-wechat.vue?vue&type=script&lang=ts"
export * from "./bind-wechat.vue?vue&type=script&lang=ts"

import "./bind-wechat.vue?vue&type=style&index=0&id=5deef459&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5deef459"]])

export default __exports__